import { BE_TO_FIELD_TITLE } from '../../profile/player/fieldTitles'

/** Profile titles + roster-only field titles for the roster form summary toast. */
export const ROSTER_BE_TO_FIELD_TITLE: Record<string, string> = {
  ...BE_TO_FIELD_TITLE,
  player_number: 'Player Number',
  player_type_id: 'Position',
  customer_identifier: 'Customer Identifier',
  sf_id: 'Salesforce ID',
}
